/* Header goes from transparent to white once the page has moved.
   Uses a class rather than inline styles so Dawn's own sticky behaviour
   (hide on scroll down, show on scroll up) keeps working untouched. */
(function () {
  var THRESHOLD = 12;
  var header;
  var ticking = false;

  function paint() {
    if (!header) return;
    header.classList.toggle('aeloo-header--scrolled', window.scrollY > THRESHOLD);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(paint);
  }

  function init() {
    header = document.querySelector('.header-wrapper');
    if (!header) return;
    paint();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
